<template>
  <form class="space-y-4" @submit.prevent="submit">
    <label class="block">
      <span class="form-label mb-2">{{ $t('common.labels.password') }}</span>
      <input
        v-model="password"
        type="password"
        name="password"
        class="form-input"
        autocomplete="current-password"
        required
        autofocus>
    </label>

    <p v-if="errorMessage" class="text-xs text-rose-300">{{ errorMessage }}</p>
  </form>
</template>

<script>
import api from '@/services/api'

export default {
  props: {
    onConfirmedCallback: {
      type: Function,
      default: null,
    },
  },
  emits: ['confirmed'],
  data() {
    return {
      password: '',
      errorMessage: null,
    }
  },
  methods: {
    async submit() {
      this.errorMessage = null

      try {
        await api.post('/user/confirm-password', {
          password: this.password,
        })

        if (typeof this.onConfirmedCallback === 'function') {
          await this.onConfirmedCallback()
        }

        this.$emit('confirmed')
      } catch (error) {
        this.errorMessage = error.response?.data?.message ?? this.$t('components.modals.confirmPassword.error')
      }
    },
  },
}
</script>
